import React from 'react';
import PropTypes from 'prop-types';
import SegmentedControl from '../ui/SegmentedControl';
import { LANGUAGES, useTranslation } from '../../i18n/LanguageContext';

/** TR / EN switch for the top bar (and the account menu on phones). */
const LanguageSwitcher = ({ layoutId, className = '' }) => {
  const { language, setLanguage, t } = useTranslation();

  return (
    <SegmentedControl
      size="sm"
      layoutId={layoutId}
      label={t('language.label')}
      value={language}
      onChange={setLanguage}
      options={LANGUAGES.map((entry) => ({ value: entry.code, label: entry.short, title: entry.label }))}
      className={className}
    />
  );
};

LanguageSwitcher.propTypes = {
  layoutId: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default LanguageSwitcher;
